export default __webpack_public_path__ + "static/1-f0f444493fcb2338d10ea1361f9c6a27.png";